import type { IdentityPort, Profile, ProfileDraft } from '@/ports/identity';
import { readJson, remove, writeJson } from './kv';

const KEY = 'profile';

function isProfile(value: unknown): value is Profile {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.id === 'string' &&
    typeof v.name === 'string' &&
    typeof v.age === 'number' &&
    typeof v.createdAt === 'string'
  );
}

export class LocalIdentity implements IdentityPort {
  async current(): Promise<Profile | null> {
    const stored = readJson<unknown>(KEY);
    return isProfile(stored) ? stored : null;
  }

  async save(draft: ProfileDraft): Promise<Profile> {
    const existing = await this.current();
    const profile: Profile = {
      id: existing?.id ?? crypto.randomUUID(),
      createdAt: existing?.createdAt ?? new Date().toISOString(),
      name: draft.name.trim(),
      age: draft.age,
    };
    writeJson(KEY, profile);
    return profile;
  }

  async clear(): Promise<void> {
    remove(KEY);
  }
}
